import Vue from 'vue'

export default {
  getAll () {
    return Vue.http.get('/locations')
  },

  get (locationId) {
    return Vue.http.get(`/locations/${locationId}`)
  },

  sales (locationId) {
    return Vue.http.get(`/locations/${locationId}/sales`)
  }
}
